import "./Terms.module.css";
import Header from "@/reusable_sections/Header";
import TermsHeader from "./sections/TermsHeader";
import TermsOfService from "./sections/TermsOfService";
import EstimateForm from "./sections/EstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function TermsPage() {
  return <div>
      <Header />
      <TermsHeader />
      <TermsOfService />
      <EstimateForm />
      <Footer />
    </div>;
}